import { apiClient } from "./client";

export async function savePreferencesApi(payload) {
  const res = await apiClient.post("/jobs/preferences", payload);
  return res.data;
}

export async function fetchPreferencesApi() {
  const res = await apiClient.get("/jobs/preferences");
  return res.data;
}

export async function createJobApi(payload) {
  const res = await apiClient.post("/jobs", payload);
  return res.data;
}

export async function updateJobApi(jobId, payload) {
  const res = await apiClient.put(`/jobs/${jobId}`, payload);
  return res.data;
}

export async function updateJobStatusApi(jobId, status) {
  const res = await apiClient.patch(`/jobs/${jobId}/status`, { status });
  return res.data;
}

export async function fetchHRJobsApi() {
  const res = await apiClient.get("/jobs/hr");
  return res.data;
}

/**
 * The open-jobs lists come a page at a time, newest first (the server sends
 * 20 by default, 50 at most). A full page means there may be more: the next
 * one is asked for with `skip` = jobs held.
 */
export const JOBS_PAGE_SIZE = 20;

/** A page of the open jobs, by words in them and by industry (both optional). */
export async function fetchActiveJobsApi(
  search = "",
  industryId = "",
  skip = 0,
) {
  const params = { skip, take: JOBS_PAGE_SIZE };
  if (search) params.search = search;
  if (industryId) params.industryId = industryId;
  const res = await apiClient.get("/jobs/active", { params });
  return res.data;
}

/** A page of the open jobs that meet every must-have in the preferences. */
export async function fetchMatchedJobsApi(skip = 0) {
  const res = await apiClient.get("/jobs/matched", {
    params: { skip, take: JOBS_PAGE_SIZE },
  });
  return res.data;
}

/**
 * The signed-in professional's own applications, newest first, without the
 * CV and resume contents.
 */
export async function fetchAppliedJobsApi() {
  const res = await apiClient.get("/jobs/applied", {
    params: { files: "none" },
  });
  return res.data;
}

export async function fetchJobByIdApi(jobId) {
  const res = await apiClient.get(`/jobs/${jobId}`);
  return res.data;
}

export async function applyToJobApi(jobId, payload) {
  const res = await apiClient.post(`/jobs/${jobId}/apply`, payload);
  return res.data;
}

export async function fetchHRApplicantsApi() {
  const res = await apiClient.get("/jobs/hr/applicants");
  return res.data;
}

export async function updateApplicantStatusApi(applicantId, status) {
  const res = await apiClient.patch(`/jobs/applicants/${applicantId}/status`, {
    status,
  });
  return res.data;
}

export async function deleteJobApi(jobId) {
  const res = await apiClient.delete(`/jobs/${jobId}`);
  return res.data;
}

export async function fetchIndustriesApi() {
  const res = await apiClient.get("/jobs/industries");
  return res.data;
}
